<template>
  <div class="static_page_view">
    <div class="page_card">
      <h1>{{ pageTitle }}</h1>

      <static-page-loader v-if="loading" />

      <div v-else-if="error" class="page_state page_state--error">
        <i class="fas fa-exclamation-circle"></i>
        <span>{{ error }}</span>
      </div>

      <div
        v-else
        class="page_content"
        v-html="content"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { fetchStaticPageContent, STATIC_PAGES } from "@/services/generalApi";
import StaticPageLoader from "@/components/general/StaticPageLoader.vue";

export default {
  name: "StaticPageView",

  components: {
    StaticPageLoader,
  },

  props: {
    pageKey: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      content: "",
      loading: true,
      error: null,
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),

    pageConfig() {
      return STATIC_PAGES[this.pageKey] || null;
    },

    pageTitle() {
      return this.pageConfig
        ? this.$t(this.pageConfig.titleKey)
        : this.$t("STATIC_PAGES.page");
    },
  },

  watch: {
    getAppLocale() {
      this.loadContent();
    },
    pageKey() {
      this.loadContent();
    },
  },

  methods: {
    async loadContent() {
      if (!this.pageConfig) {
        this.loading = false;
        this.error = this.$t("STATIC_PAGES.notFound");
        return;
      }

      this.loading = true;
      this.error = null;

      try {
        this.content = await fetchStaticPageContent(
          this.pageConfig.apiSlug,
          this.getAppLocale
        );
      } catch (error) {
        this.error =
          error.response?.data?.message || this.$t("STATIC_PAGES.loadError");
      } finally {
        this.loading = false;
      }
    },
  },

  created() {
    this.loadContent();
  },
};
</script>
